export default "__VITE_ASSET__BVrkQhGD__"